<template>
    <v-modal-validated title="Añadir un nuevo procurador"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="add-attorneys-modal"
                       @closed="closeModal"
                       @accepted="addAttorney">

        <div class="user-form row">
            <div class="form-group col-6">
                <label for="name">Nombre*:</label>
                <Field type="text" id="name" name="name" class="form-control"/>

                <ErrorMessage name="name"/>
            </div>

            <div class="form-group col-6">
                <label for="surname">Apellidos*:</label>
                <Field type="text" id="surname" name="surname" class="form-control"/>

                <ErrorMessage name="surname"/>
            </div>
        </div>

        <div class="user-form row">
            <div class="form-group col-4">
                <label for="dni">DNI:</label>
                <Field type="text" id="dni" name="dni" class="form-control"/>

                <ErrorMessage name="dni"/>
            </div>

            <div class="form-group col-4">
                <label for="collegiate_number">Número de colegiado:</label>
                <Field type="text" id="collegiate_number" name="collegiate_number" class="form-control"/>

                <ErrorMessage name="collegiate_number"/>
            </div>

            <div class="form-group col-4">
                <label for="college">Colegio:</label>
                <Field type="text" id="college" name="college" class="form-control"/>

                <ErrorMessage name="college"/>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import {createAttorney} from "../../../helpers/requests/RequestsAttorneys";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

export default {
    name: "AttorneysListAddModal",
    components: {VModalValidated, Form, Field, ErrorMessage},
    data() {
        const rules = yup.object({
            name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
            surname: yup.string().required('Debes incluir como mínimo un apellido').max(50, 'Debe tener como máximo 50 caracteres'),
            dni: yup.string().nullable().max(10, 'Debe tener como máximo 10 caracteres'),
            collegiate_number: yup.string().max(50, 'Debe tener como máximo 50 caracteres'),
            college: yup.string().max(50, 'Debe tener como máximo 50 caracteres'),
        });

        return {
            rules
        }
    },
    methods: {
        async addAttorney(data) {
            try {
                await createAttorney(data);

                this.$store.dispatch('app/setToastMessage', 'Procurador añadido');

                this.closeModal();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al crear al procurador');

                this.closeModal();
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
